class CampaignScroll extends HTMLElement {
  constructor() {
    super();

    this.wrap = this;
    this.content = this.querySelector('.campaign__blocks, .campaign__list-inner');

    this.updateBodyHeight = this.updateBodyHeight.bind(this);
    this.setup();
  }

  updateBodyHeight() {
    document.body.style.height = this.content.getBoundingClientRect().width + 'px';
    this.trigger.refresh();
  }

  setup() {
    let mm = gsap.matchMedia();

    mm.add('(min-width: 990px)', () => {
      document.body.style.height = this.content.getBoundingClientRect().width + 'px';

      setTimeout(this.updateBodyHeight, 1000);

      this.trigger = ScrollTrigger.create({
        trigger: document.body,
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: (self) => {
          const width = this.content.getBoundingClientRect().width - window.innerWidth;

          this.content.style.transform = `translateX(${-self.progress * width}px)`;
        },
      });

      return () => {
        document.body.style.height = 'auto';
        this.content.style.transform = ``;
      };
    });
  }
}

customElements.define('campaign-scroll', CampaignScroll);
